@if (chatNotFound()) {
  <div class="chat-not-found-wrap">
    <app-chat-not-found (backToPolaris)="navigateToPolarisHome()"></app-chat-not-found>
  </div>
} @else {
<div class="chat-container">
  <div class="chat-main">
  @if (isShareableChat()) {
    <button class="share-chat-btn" data-testid="share-chat-btn" (click)="openShareModal()">
      <img [src]="'/svg/share-arrow.svg' | assetVersion" width="16" height="16" alt="" />
      Share
    </button>
  }
  <div #messagesContainer class="messages-container">
    @if (isSharedView) {
      <div class="shared-copy-banner">
        <img [src]="'/svg/share-arrow.svg' | assetVersion" width="13" height="13" alt="" />
        This is a copy of a shared chat
      </div>
    }
    @if (showEmptyState()) {
      <app-empty-chat-message class="empty-chat-message"></app-empty-chat-message>
    }
    @for (message of messages(); track message.timestamp + message.author; let i = $index) {
      @if (i === forkBoundaryIndex()) {
        <div class="fork-divider">
          <span class="fork-divider__line"></span>
          <span class="fork-divider__label">
            <img [src]="'/svg/eye.svg' | assetVersion" width="13" height="13" alt="" />
            Messages beyond this point are only visible to you
          </span>
          <span class="fork-divider__line"></span>
        </div>
      }
      @switch (message.author) {
        @case ('user') {
          <app-user-message class="user-message" [message]="message"></app-user-message>
        }
        @case ('assistant') {
          <app-copilot-message
            class="copilot-message"
            [message]="message"
            [sendMessage]="chatId()"
            [shareable]="isShareableChat()"
            [shouldDisplayRetryButton]="isLatestAssistantMessage(message)"
            (retryRequested)="onRetryRequested($event)"
            (responseSelected)="onResponseSelected($event)"
            (chatNotFound)="onFollowUpChatNotFound()"
          ></app-copilot-message>
        }
      }
    }
    <div #scrollAnchor></div>
  </div>
  <div class="prompt-bar-container">
    <app-copilot-prompt-bar class="prompt-bar" [promptControl]="promptControl"
                            [showModelSelector]="canSelectV2"
                            [selectedModel]="chatModelVersion()"
                            [modelSelectorDisabled]="true"
                            (sendMessage)="onSendMessage($event)"
                            [disabled]="isCopyInFlight()"
                            [maxHeight]="312"></app-copilot-prompt-bar>
    @if (myBrand()) {
      <div class="copilot-brand-selection">
        <app-two-stage-brand-picker
          [placeholderText]="'Select brands for tailored answers'"
          [competitorSelectionText]="'Select competitors for comparison'"
          [myBrand]="myBrand()"
          [myCompetitors]="myCompetitors()"
        >
        </app-two-stage-brand-picker>
      </div>
    }
    @if (isChatShared() && !isSharedView) {
      <p class="owner-share-note">This chat is shared with your colleagues. New messages you send here will be visible to them, too.</p>
    }
  </div>
  </div>
  @if (hasChatLibrary()) {
    <div class="chat-library-container" [class.open]="isLibraryOpen()">
      <app-chat-library-drawer [chatId]="chatId()" [messages]="messages()"></app-chat-library-drawer>
    </div>
  }
</div>
}
